module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "user-chats"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    attrs: {
      "id": "public-list"
    }
  }, _vm._l((_vm.PublicChats), function(publicChat) {
    return _c('a', {
      key: publicChat.id,
      class: {
        selected: _vm.chatId === 'public.' + publicChat.id
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.switchToChat('public.' + publicChat.id)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(publicChat.alias))]), _vm._v(" "), (publicChat.unreadMessages != 0) ? _c('span', {
      staticClass: "unread-message-count"
    }, [_vm._v(_vm._s(publicChat.unreadMessages))]) : _vm._e()])
  }), 0), _vm._v(" "), (_vm.addGroupMode) ? [_vm._m(1), _vm._v(" "), (_vm.addGroupMode) ? _c('section', {
    attrs: {
      "id": "new-group-form"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGroupName),
      expression: "newGroupName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Group Name...",
      "disabled": _vm.savingNewGroup
    },
    domProps: {
      "value": (_vm.newGroupName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newGroupName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.savingNewGroup
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addGroupMode = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    attrs: {
      "disabled": _vm.savingNewGroup
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createNewGroup($event)
      }
    }
  }, [_vm._v("Create")])])]) : _vm._e()] : _vm._e(), _vm._v(" "), (!_vm.addGroupMode) ? [_vm._m(2), _vm._v(" "), _c('section', {
    attrs: {
      "id": "groups-list"
    }
  }, [_c('span', {
    staticClass: "add-group-button"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addGroupMode = true
      }
    }
  }, [_vm._v("Create a New Group "), _c('i', {
    staticClass: "fa fa-plus-circle"
  })])]), _vm._v(" "), _vm._l((_vm.groupChats), function(groupChat) {
    return _c('a', {
      key: groupChat.id,
      class: {
        selected: _vm.chatId === 'group.' + groupChat.id
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.switchToChat('group.' + groupChat.id)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(groupChat.alias))]), _vm._v(" "), (groupChat.unreadMessages != 0) ? _c('span', {
      staticClass: "unread-message-count"
    }, [_vm._v(_vm._s(groupChat.unreadMessages))]) : _vm._e()])
  })], 2)] : _vm._e(), _vm._v(" "), (_vm.friendChats.length > 0) ? [_vm._m(3), _vm._v(" "), _c('section', {
    attrs: {
      "id": "friends-list"
    }
  }, _vm._l((_vm.friendChats), function(friendChat) {
    return _c('a', {
      key: friendChat.friendChatId,
      class: {
        selected: _vm.chatId === 'private.' + friendChat.friendChatId
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.switchToChat('private.' + friendChat.friendChatId)
        }
      }
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": _vm.generateAvatarImage(friendChat)
      }
    }), _vm._v(" "), (friendChat.isOnline) ? _c('i', {
      staticClass: "fa fa-circle online-status"
    }) : _vm._e(), _vm._v(" "), (friendChat.unreadMessages != 0) ? _c('span', {
      staticClass: "unread-message-count"
    }, [_vm._v(_vm._s(friendChat.unreadMessages))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "friends-list-alias"
    }, [_vm._v(_vm._s(friendChat.alias))])])
  }), 0)] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('i', {
    staticClass: "fa fa-fw fa-home"
  }), _vm._v(" Public Chats")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('i', {
    staticClass: "fa fa-fw fa-home"
  }), _vm._v(" Create a new Group")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('i', {
    staticClass: "fa fa-fw fa-group"
  }), _vm._v(" Group Chats")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('i', {
    staticClass: "fa fa-fw fa-user"
  }), _vm._v(" Friend Chats")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c30b8e2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Chatroom/ChatSidePanelWidgets/UserChats.vue
// module id = 402
// module chunks = 1